import photoPalmarino from "@/assets/founder-palmarino.jpg";
import photoLeonardo from "@/assets/founder-leonardo.jpg";
import photoMarcelo from "@/assets/founder-marcelo.jpg";
import { Linkedin } from "lucide-react";

const founders = [
  { name: "Palmarino Frizzo Neto", photo: photoPalmarino, linkedin: "https://www.linkedin.com/in/palmarinofrizzoneto/", objectPosition: "center 20%" },
  { name: "Leonardo Silva", photo: photoLeonardo, linkedin: "https://www.linkedin.com/in/leonardosilvabr/", objectPosition: "center 15%" },
  { name: "Marcelo M. Franco", photo: photoMarcelo, linkedin: "https://www.linkedin.com/in/marcelomfranco/", objectPosition: "center 10%" },
];

const TeamSection = () => (
  <section className="section-dark py-14 md:py-20">
    <div className="container mx-auto px-6">
      <div className="max-w-3xl mx-auto text-center mb-14">
        <p className="text-primary font-body font-semibold tracking-widest uppercase text-[13px] mb-5">Quem Somos</p>
        <h2 className="text-[25px] md:text-[31px] lg:text-[39px] font-heading font-bold leading-[1.2em] tracking-[-1px] text-surface-dark-foreground mb-6">
          Já sentamos dos dois lados da mesa.
        </h2>
        <p className="text-surface-dark-foreground/70 font-body text-[16px] font-normal leading-[1.5em]">
          Somos sócios, conselheiros e mediadores que já atuaram como executivos, empreendedores e conselheiros independentes.
        </p>
        <p className="text-surface-dark-foreground/60 font-body mt-4 text-[16px] font-normal leading-[1.5em]">
          Já vimos sociedades promissoras se perderem — não por falta de mercado, produto ou dinheiro — mas por conflitos mal endereçados no momento certo.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-12 md:gap-16">
        {founders.map((f) => (
          <a
            key={f.name}
            href={f.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="group text-center"
          >
            <div className="w-36 h-36 md:w-44 md:h-44 rounded-full overflow-hidden border-3 border-primary/30 group-hover:border-primary transition-colors mx-auto mb-4">
              <img src={f.photo} alt={f.name} className="w-full h-full object-cover" style={{ objectPosition: f.objectPosition }} />
            </div>
            <p className="font-heading text-[20px] font-bold leading-[1.4em] tracking-[-0.5px] text-surface-dark-foreground">{f.name}</p>
            <Linkedin className="w-5 h-5 text-primary mx-auto mt-2 group-hover:scale-110 transition-transform" />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default TeamSection;
